<div>
  <div class="tw-flex tw-justify-end tw-mr-[5px]">
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <h4 id="title" class="tw-text-center tw-mb-10">Select Destination</h4>
  <div class="tw-px-6">
    <search-filter
      [filterConfig]="filterConfig"
      [search]="search"
      [doSearch]="doSearch"
      class="tw-mb-4"
    />
    <mat-divider class="light tw-mt-4"></mat-divider>
    <folder-path
      [folderTree]="selectFolderDialogService.folderTree()"
      [folderId]="selectFolderDialogService.currentParentFolderId"
      (folderClicked)="enterFolder({ id: $event })"
      [rootName]="data.kind + 's'"
    />
    <mat-divider class="light tw-mb-4"></mat-divider>
    <table class="tw-w-full">
      <thead>
        <tr class="list-header">
          <th>Name</th>
        </tr>
      </thead>
    </table>
  </div>
  <mat-dialog-content
    class="tw-max-h-[50vh] tw-min-h-[30vh] tw-overflow-y-auto"
  >
    <table
      class="tw-table-fixed tw-w-full"
      rvSpinner="folders-list-loader"
      [rvShowSpinner]="selectFolderDialogService.loading()"
    >
      <tbody>
        @for (folder of selectFolderDialogService.folders(); track folder.id) {
          <tr
            (click)="enterFolder(folder)"
            [class.disabled]="shouldDisable(folder.id)"
          >
            <td class="tw-w-full tw-max-w-0 tw-overflow-hidden">
              <div
                class="tw-flex tw-items-center tw-gap-2.5 tw-overflow-hidden"
              >
                <mat-checkbox
                  [checked]="folder.isSelected"
                  (click)="$event.stopPropagation()"
                  (change)="selectFolder(folder)"
                  [disabled]="shouldDisable(folder.id)"
                />
                <mat-icon class="tw-text-gray-500" svgIcon="folder" />
                <span
                  class="tw-font-semibold tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-block"
                >
                  {{ folder.name }}
                </span>
              </div>
            </td>
          </tr>
        } @empty {
          @if (selectFolderDialogService.loading()) {
            <tr>
              <td class="tw-text-center tw-text-gray-500">
                Loading folders...
              </td>
            </tr>
          } @else if (search.query) {
            <tr>
              <td class="tw-text-center tw-text-gray-500">
                <span>No folders found</span>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </mat-dialog-content>
  <mat-divider class="light"></mat-divider>
  <mat-dialog-actions align="end" class="tw-p-6 tw-gap-2">
    <button rv-button variant="secondary" (click)="dialogRef.close()">
      Cancel
    </button>
    <new-folder-button
      [existingFiles]="selectFolderDialogService.folders()"
      [parentId]="selectFolderDialogService.currentParentFolderId"
      [kind]="data.kind"
      (folderAdded)="handleFolderCreated()"
    />
    <button
      rv-button
      (click)="moveFolder()"
      [disabled]="selectFolderDialogService.loading()"
    >
      Move{{ someFolderIsSelected ? '' : ' Here' }}
    </button>
  </mat-dialog-actions>
</div>
